import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RealUserGuard } from '@core/feature';
import { MyAccountDataAccessModule } from '@my-account/data-access';
import {
  isForemanGuard,
  isNotForemanGuard,
  MyAccountFeatureModule,
  orderDetailsPageResolver,
} from '@my-account/feature';
import { MyAccountPageComponent } from '@my-account/ui';
import { OfflineOrderService, OrderService } from '@order/feature';
import { OrderShellModule } from '@order/shell';
import { SeoOrderDetailsPageService, SeoOrdersPageService, seoPageResolver, SeoPageService } from '@seo/feature';
import { UserProfileCoreModule, UserProfileOccModule } from '@spartacus/user';

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./lazy-reexports/my-account-page-template').then((m) => m.MyAccountPageTemplateComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: MyAccountPageComponent,
        resolve: { seoPage: seoPageResolver('my-account') },
      },
      {
        path: 'orders',
        loadComponent: () => import('./lazy-reexports/order-history-page').then((m) => m.OrderHistoryPageComponent),
        resolve: { seoPage: seoPageResolver('orders') },
        providers: [{ provide: SeoPageService, useExisting: SeoOrdersPageService }],
        data: { semanticName: 'orders' },
      },
      {
        path: 'personal-managers',
        loadComponent: () => import('./lazy-reexports/personal-managers-page').then((m) => m.PersonalManagersComponent),
        resolve: { seoPage: seoPageResolver('personal-managers') },
      },
      {
        path: 'update-profile',
        loadComponent: () => import('./lazy-reexports/update-profile-page').then((m) => m.UpdateProfilePageComponent),
        resolve: { seoPage: seoPageResolver('update-profile') },
      },
      {
        path: 'payments',
        loadComponent: () => import('./lazy-reexports/payments-page').then((m) => m.PaymentsPageComponent),
        canActivate: [RealUserGuard],
        resolve: { seoPage: seoPageResolver('payments') },
      },
      {
        path: 'points',
        loadComponent: () => import('./lazy-reexports/points-page').then((m) => m.PointsPageComponent),
        data: { semanticName: 'points' },
        canActivate: [isNotForemanGuard],
        resolve: { seoPage: seoPageResolver('points') },
      },
      {
        path: 'companies-list',
        loadComponent: () => import('./lazy-reexports/companies-list-page').then((m) => m.CompaniesListPageComponent),
        resolve: { seoPage: seoPageResolver('companies-list') },
      },
      {
        path: 'order-documents',
        loadComponent: () => import('./lazy-reexports/order-documents-page').then((m) => m.OrderDocumentsPageComponent),
        resolve: { seoPage: seoPageResolver('order-documents') },
      },
      {
        path: 'promocodes',
        loadComponent: () => import('./lazy-reexports/promocodes-page').then((m) => m.PromocodesPageComponent),
        data: { semanticName: 'promocodes' },
        canActivate: [isForemanGuard],
        resolve: { seoPage: seoPageResolver('promocodes') },
      },
    ],
  },
  {
    path: 'order',
    children: [
      {
        path: ':orderCode',
        pathMatch: 'full',
        loadComponent: () => import('./lazy-reexports/order-details-page').then((m) => m.OrderDetailsPageComponent),
        resolve: {
          seoPage: seoPageResolver('order'),
          orderDetails: orderDetailsPageResolver,
        },
        providers: [{ provide: SeoPageService, useExisting: SeoOrderDetailsPageService }],
        data: { semanticName: 'online-order' },
      },
      {
        path: '',
        redirectTo: '/not-found',
      },
    ],
  },
  {
    path: 'orders/offline',
    children: [
      {
        path: ':orderCode',
        loadComponent: () => import('./lazy-reexports/order-details-page').then((m) => m.OrderDetailsPageComponent),
        resolve: {
          seoPage: seoPageResolver('order'),
          orderDetails: orderDetailsPageResolver,
        },
        providers: [
          { provide: SeoPageService, useExisting: SeoOrderDetailsPageService },
          { provide: OrderService, useExisting: OfflineOrderService },
        ],
        data: { semanticName: 'offline-order' },
      },
      {
        path: '',
        redirectTo: '/not-found',
      },
    ],
  },
];

@NgModule({
  imports: [
    OrderShellModule,
    UserProfileCoreModule,
    UserProfileOccModule,
    MyAccountDataAccessModule,
    MyAccountFeatureModule,
    RouterModule.forChild(routes),
  ],
})
export class MyAccountShellModule {}
